import React from 'react'

import { PermissionChecker } from '../../session'
import ConfigLoader from './_load/ConfigLoader'
import ControlledModal from '../../../components/modals/ControlledModal'
import EditConfigForm from './EditConfigForm'
import Line from '../../../packages/kiti/components/helpers/Line'
import ModalHeader from './ModalHeader'
import Separator from '../../../components/helpers/Separator'

const EditAvailabilityStatusSourceConfigModal = props => {
  return (
    <ControlledModal width="28rem" {...props}>
      <PermissionChecker permission="editPlaceAvailabilityStatus">
        <ConfigLoader>
          <ModalHeader />
          <Line />
          <Separator weight={4} />
          <EditConfigForm />
        </ConfigLoader>
      </PermissionChecker>
    </ControlledModal>
  )
}

export default EditAvailabilityStatusSourceConfigModal
